export default {
    "Testimonials.index.249707-0": "众多满意客户",
    "Testimonials.index.249707-1": "集团总部和各分公司均设置了电话服务专线。总部、第三方通过专线电话对用户进行定期或不约定回访， 监督服务人员的工作质量，并承诺对于投诉服务质量问题，2小时内做出回应并处理解决。",
    "Testimonials.index.249707-2": "旧金山",
    "Testimonials.index.249707-3": "伦敦",
    "Testimonials.index.249707-4": "柏林",
    "Testimonials.index.249707-5": "巴黎"
}